// extracted by css-extract-rspack-plugin
export default {"flexContainer":"MneSA","selected":"MToLn","flexContent":"QD4UL","resizeHandle":"AW2tX","resizing":"wytmI"};